import { createSelector } from 'reselect';

export const nearestMfcSelector = state => state.nearestMfc;

export const mfcDomainSelector = state => state.mfc;

export const mfcSelector = createSelector(
  mfcDomainSelector,
  subState => subState
);
